import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { RippleModule } from 'primeng/ripple';
import { FooterComponent } from './footer/footer.component';
import { TopbarComponent } from './topbar/topbar.component';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { NavigationUtils } from '@ipensii/shared/util-shared';

@Component({
  selector: 'ip-layout',
  standalone: true,
  imports: [CommonModule, ButtonModule, DividerModule, RippleModule, FooterComponent, TopbarComponent, RouterOutlet],
  templateUrl: 'layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent {
  router = inject(Router);
  route = inject(ActivatedRoute);
  colorizedMenu = false;

  constructor() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe({
      next: () => {
        const data = NavigationUtils.routeNestedParamsUtils(this.route.snapshot);
        if (Object.keys(data).length && data['colorizedMenu']) this.colorizedMenu = data['colorizedMenu'];
        else this.colorizedMenu = false;
      },
    });
  }
}
